import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, DatePicker, Input, Layout, Menu, message, Space } from "antd";
import React from "react";
import Header from "../../../Components/HeaderComponent";
import { error_message } from "../../../Constant";
import { withScroll } from "../../../HOC/withScroll";
import {
  MIS_DUMP_DOWNLOAD,
  NonAGent_MIS_DUMP_DOWNLOAD,
  Policy_Excel_agent_Download,
  Policy_Excel_Download,
} from "../../../Services/endpoints";
import { color } from "../../../theme";
import "./style.css";
import axios from "axios";
import {  useSelector } from "react-redux";
import dayjs from "dayjs";

const { Content, Sider } = Layout;
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [getItem("MIS Dump", "1", <FontAwesomeIcon icon={faHome} />)];

const { RangePicker } = DatePicker;
let finalURL = null;

const DashBoardPage = () => {
  const { tokenMis, userType } = useSelector((state) => state.policyDetails);
  const [value, setValue] = React.useState("");
  let urlType = "";

  const onDateChange = (dates, dateStrings) => {
    let url =
        userType === "ROLE_USER"
        ? MIS_DUMP_DOWNLOAD
        : NonAGent_MIS_DUMP_DOWNLOAD;
    if (dates) {
      finalURL = `${url}fromDate=${dateStrings[0]}&toDate=${dateStrings[1]}`;
    } else {
      message.error(error_message.common_error);
    }
  };

  const getFile = async () => {
    let BearerToken =
      tokenMis === "null"
        ? "Bearer 07188b28-78d5-45b9-99fa-798a12d29588"
        : `Bearer ${tokenMis}`;
    const policyDownloadUrl =
      userType === "ROLE_USER"
        ? Policy_Excel_agent_Download
        : Policy_Excel_Download;
    urlType = value !== "" ? `${policyDownloadUrl}${value}` : finalURL;
    return await axios.get(`${urlType}`, {
      responseType: "arraybuffer",
      headers: { "Content-Type": "blob", Authorization: BearerToken },
    });
  };

  const onDownload = async () => {
    if (!finalURL && value === "")
      return message.error(error_message.download_error);
    try {
      const resp = await getFile();
      const link = document.createElement("a");
      const fileName = "MIS_DUMP.xlsx";
      link.setAttribute("download", fileName);
      link.href = URL.createObjectURL(new Blob([resp.data]));
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      message.error(error_message.common_error);
    }
  };
  return (
    <>
      <Header />
      <Layout className={"cls_mghunsup_1cbea5"}>
        <Sider collapsible>
          <div className="logo" />
          <Menu
            theme="dark"
            defaultSelectedKeys={["1"]}
            mode="inline"
            items={items}
          />
        </Sider>
        <Layout className="site-layout">
          <Content className={"cls_mghunsup_5c99f3"}>
            <div className="download_dump_container">
              <div className="date-wrapper">
                <div>
                  <Input
                    placeholder={"Enter Policy Number "}
                    maxLength={20}
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    className={"cls_mghunsup_722516"}
                  />
                </div>
                <div>
                  <div className="date-wrapper">
                    <Space size="large">
                      <RangePicker
                        disabledDate={(e) => e && e.valueOf() > Date.now()}
                        presets={[
                          { label: 'Today', value: [dayjs(), dayjs()] },
                          { label: 'This Month', value: [dayjs().startOf("month"),
                            dayjs(),] },
                        ]}
                        format="DD-MM-YYYY"
                        onChange={onDateChange}
                      />
                      <Button
                        type="primary"
                        onClick={onDownload}
                        className={"cls_mghunsuq_1e0faf"}
                      >
                        Download
                      </Button>
                    </Space>
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default withScroll(DashBoardPage);
